require('./fact-thumb-list.component.scss');



// WEBPACK FOOTER //
// ./src/facts/fact-thumb-list.component.js